import conversions from '@sstdev/lib_epc-conversions';
import { rfidStrategy } from 'lib_ui-services';

/**
 * @param {*} hNode
 * @returns{(value: string) => string}
 */
// eslint-disable-next-line no-unused-vars
const toAsciiFromHex = hNode => value => {
    const hex = value.toString();
    // Only decode when the stored hex is unambiguously printable ASCII; otherwise
    // keep the raw hex rather than rendering gibberish like "6S██s" for raw-hex
    // tags (1050).
    return rfidStrategy.canDisplayAsAscii(hex) ? conversions.ascii.fromHex(hex) : hex;
};

export default toAsciiFromHex;
